import Vue from 'vue'
import App from './main/views/default/App.vue'
import router from './main/router'
import store from './main/store'
import zqylModuleFunction from 'zqyl-module-function'
import ElementUI from 'element-ui';
import './main/global/';
import 'babel-polyfill'
import 'element-ui/lib/theme-chalk/index.css';
import './main/assets/style/main.less'
// import VueAMap from 'vue-amap';
import 'vant/lib/index.css';
import inputPolyFill from "ie9-oninput-polyfill"
import ClientMonitor from 'skywalking-client-js';
Vue.prototype.$function = zqylModuleFunction;
Vue.use(inputPolyFill);
router.beforeEach((to, from, next) => {
    //路由发生变化修改页面title
    if(to.meta.title){
        document.title = to.meta.title
    }
    next()
});

Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'small'});

import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'vue-swipe/dist/vue-swipe.css'
Vue.use(VueAwesomeSwiper, /* { default global options } */)


ClientMonitor.setPerformance({
    collector: location.protocol+"//"+location.hostname+":"+location.port,
    service: 'skywalking-rocketbot-ui-master',
    serviceVersion: '1.0.0',
    pagePath: location.href,
    useFmp: true,
    enableSPA:true
});

// j将地图单独引入
// Vue.use(VueAMap);
// // 初始化vue-amap
// VueAMap.initAMapApiLoader({
//     // 申请的高德key
//     key: '7066820febd694db069d2e1c79d2742f',
//     // 插件集合
//     plugin: ['AMap.Autocomplete','AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']
// });

async function setnamespace () {
	await Vue.prototype.$axiosJson.get("/special/serverConf.json").then(res=>{
		let version = res.data.namespace || ""
		window.namespace = version;
	}).catch((e)=>{
		throw Error(e)
	})
}
async function getConfig(){
    return Vue.prototype.$axiosJson.get("/project.config.json").then(res=>{
        let config = res.data;
        if(navigator.userAgent.indexOf("MSIE 9.0") !== -1){
            config.project.name =  config.project.name + '/#';
            config.project.fileProjectName =  config.project.fileProjectName + '/#';
            config.server['root'].url =  config.server['root'].url + '/#';
            config.server['zqyl-user'].address =  config.server['zqyl-user'].address + '/#';
            config.server['zqyl-draft'].address = config.server['zqyl-draft'].address + '/#';
            // 云店较为特殊
            config.server['zqyl-yd'].address =  config.server['zqyl-yd'].address + '/#';
            config.server['zqyl-pjs'].name =  config.server['zqyl-pjs'].name + '/#';
        }

        localStorage.setItem("config",JSON.stringify(config));
        Vue.prototype.$config=config;
    })
}
async function createApp(){
    new Vue({
        router,
        store,
        render: h => h(App),
        watch:{
            $route:{
                handler(){
                    this.$nextTick(function(){
                        if(!('placeholder' in document.createElement('input'))){//IE9 不支持
						    var mInput = document.getElementsByTagName('input');
						    for(var i=0;i<mInput.length;i++){
                                //获取所有表单placeholder
                                var placeholderValue = mInput[i].getAttribute('placeholder')?mInput[i].getAttribute('placeholder'):'';
                                mInput[i].setAttribute('data-value',placeholderValue);//避免失去焦点获取不到之前的placeholder（因为获取焦点已经清空并赋值给value）
                                if(mInput[i].value=='' || mInput[i].value==null){
                                    mInput[i].value=placeholderValue;
                                }
                                mInput[i].onfocus=function(){
                                    let currentPlace=this.getAttribute('placeholder')?this.getAttribute('placeholder'):'';
                                    if(this.value==currentPlace){
                                        this.value='';
                                    }
                                }
                                mInput[i].onblur=function(){
                                    var setPlaceHolder=this.getAttribute('data-value');//获取焦点清空placeholder之前的值
                                    var currentPlace=this.getAttribute('placeholder')?this.getAttribute('placeholder'):'';
                                    if(this.value=='' || this.value==currentPlace){
                                        this.value=setPlaceHolder;//设置获取焦点清空placeholder之前的值为新的placeholder
                                    }
                                }

						    }
                        }
                    });
                }
            }
        }
    }).$mount(document.body.appendChild(document.createElement("div")));
}
(async function(){
    await setnamespace();
    await getConfig();
    await createApp();
})()


